module.exports = __webpack_public_path__ + "static/media/youwu61.bc84b331.png";